/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type GetTireBoundResponse = {
  agreeDt: string;
  specType: string;
  cars: string;
  mdy: string;
  ignOnTime: string;
  ignOffTime: string;
  tripLength: number;
  drvDistance: number;
  normalTime: number;
  firstFl: number;
  firstFr: number;
  firstRl: number;
  firstRr: number;
  firstUnit: number;
  cstaAvg: number;
  tireTime: string;
  scoreTime: string;
  flBound: GetTireBoundResponse.flBound;
  frBound: GetTireBoundResponse.frBound;
  rlBound: GetTireBoundResponse.rlBound;
  rrBound: GetTireBoundResponse.rrBound;
  unsupported: boolean;
};
export namespace GetTireBoundResponse {
  export enum flBound {
    INBOUND = 'inbound',
    LOWER = 'lower',
    HIGHER = 'higher',
  }
  export enum frBound {
    INBOUND = 'inbound',
    LOWER = 'lower',
    HIGHER = 'higher',
  }
  export enum rlBound {
    INBOUND = 'inbound',
    LOWER = 'lower',
    HIGHER = 'higher',
  }
  export enum rrBound {
    INBOUND = 'inbound',
    LOWER = 'lower',
    HIGHER = 'higher',
  }
}

